import React, { useState } from "react";
import api from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function LegalText({ text }) {
  const blocks = (text || "").split("\n");
  return (
    <div className="space-y-2 text-slate-700 leading-relaxed">
      {blocks.map((line, i) => {
        if (line.startsWith("## "))
          return <h2 key={i} className="font-head font-semibold text-slate-900 text-lg pt-4">{line.slice(3)}</h2>;
        if (line.startsWith("- "))
          return <li key={i} className="ml-5 list-disc">{line.slice(2)}</li>;
        if (!line.trim()) return null;
        return <p key={i}>{line}</p>;
      })}
    </div>
  );
}

export function VersionLine({ doc }) {
  if (!doc?.surum) return null;
  return (
    <p className="text-xs text-slate-500 mt-6 border-t pt-3" data-testid="legal-version">
      Sürüm {doc.surum}{doc.guncelleme_tarihi ? ` · Yürürlük tarihi: ${doc.guncelleme_tarihi}` : ""}
    </p>
  );
}

// Metni yeni sayfaya gitmeden açar; sepet ve form bilgileri korunur
export default function LegalLink({ slug, children, className = "" }) {
  const [open, setOpen] = useState(false);
  const [doc, setDoc] = useState(null);

  const show = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
    if (!doc) api.get(`/content/${slug}`).then((r) => setDoc(r.data)).catch(() => {});
  };

  return (
    <>
      <button type="button" onClick={show} data-testid={`legal-link-${slug}`}
        className={`text-teal-700 underline underline-offset-2 hover:text-teal-900 ${className}`}>
        {children}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid={`legal-dialog-${slug}`}>
          <DialogHeader>
            <DialogTitle className="font-head">{doc?.baslik || "Yükleniyor..."}</DialogTitle>
            <DialogDescription className="sr-only">Bilgilendirme metni</DialogDescription>
          </DialogHeader>
          {doc && <LegalText text={doc.icerik} />}
          <VersionLine doc={doc} />
          <Button onClick={() => setOpen(false)} className="bg-teal-600 hover:bg-teal-700 mt-2"
            data-testid={`legal-dialog-close-${slug}`}>Kapat</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
